import { DATA_LOADED, DATA_LOADING, PAGE_NAVIGATED } from "constants/data.const";

const initialState = {
      loading:false
 };
    
  export default function dataReducer  (state=initialState,  {
    type,
    payload
})  {
      switch (type) {
        case PAGE_NAVIGATED:
          return {
              ...state,
              loading: false
          };
        case DATA_LOADING:
          return {
            ...state,
            loading: true
          };
        case DATA_LOADED:
          return {
            ...state,
            loading: false,
          };
      default:
          return state;
      }
    };